export default __webpack_public_path__ + "static/topic24-5d4f81b3a1bc149f61209586aae6f4a3.png";